(ns manage.content-configuration-page.content-configuration.export
  (:require [common.datascript.sequence :as dbseq]
            [datascript.core :as d]
            [lemonpi.content-function.shared.macro :refer [serialize-macro]]
            [manage.content-configuration-page.context-source.shared :as cs]
            [manage.content-configuration-page.placeholder-expression.db
             :refer [pull-pattern-collection-item
                     pull-pattern-singular-placeholder-expression
                     value-string]
             :rename
             {value-string ext-singular-placeholder-expression}]))

(defn sort-by-and-remove
  "sort coll of maps by sort-attr, then remove sort-attr from each map"
  [sort-attr coll]
  (map #(dissoc % sort-attr)
       (sort-by sort-attr coll)))

(defn ext-placeholders [db placeholder-ids]
  (->>
   (d/pull-many db '[[:placeholder/name :as :name]
                     [:placeholder/type :as :type]
                     {[:collection-placeholder/structure :as :placeholders]
                      [[:placeholder/name :as :name]
                       [:placeholder/type :as :type]
                       :placeholder/visualization-order]}]
                placeholder-ids)
   ;; if the placeholder is a collection placeholder, ensure correct sorting of
   ;; placeholders in collection placeholder's structure
   (mapv #(if (= (:type %) :collection)
            (update % :placeholders (partial sort-by-and-remove :placeholder/visualization-order))
            %))))

(defn ext-collection-placeholder-expression
  [placeholder-expression]
  (for [collection-item (sort-by :collection-item/order (:collection-placeholder-expression/item placeholder-expression))]
    (for [placeholder-expression (sort-by (comp :placeholder/visualization-order :placeholder/_override) (:collection-item/override collection-item))]
      {:expr (ext-singular-placeholder-expression placeholder-expression)
       :name (get-in placeholder-expression [:placeholder/_override :placeholder/name])})))

(defn ext-placeholder-expression
  [placeholder-expression]
  (-> placeholder-expression
      (update :expr
              (if (= (:placeholder/type placeholder-expression) :collection)
                ext-collection-placeholder-expression
                ext-singular-placeholder-expression))
      (dissoc :placeholder/type)))

(defn ext-default-placeholder-value-as-rule0 [db placeholder-ids]
  {:assignments
   (->>
    ;; get the relevant attributes, per entity
    (d/pull-many db [[:placeholder/name :as :name]
                     :placeholder/type
                     {[:placeholder/default-value :as :expr]
                      (concat pull-pattern-singular-placeholder-expression
                              [{:collection-placeholder-expression/item
                                pull-pattern-collection-item}])}]
                 placeholder-ids)
    ;; set value as expr
    (mapv ext-placeholder-expression))

   :predicate true})

(defn predicate-vector [{{:context-source/keys [alias]} :context-source/_macro
                         :macro/keys [selector]
                         :predicate/keys [operator value]}]
  (cond-> [operator
           (serialize-macro (cond-> {:alias alias}
                              (some? selector) (assoc :selector selector)))]
    (some? value) (conj value)))

(defn ext-rules [db rule-ids]
  (->>
   ;; get the relevant attributes, per entity
   (d/pull-many db [[:rule/name :as :name]
                    {[:rule/assignment :as :assignments]
                     (concat pull-pattern-singular-placeholder-expression
                             [{:placeholder/_override
                               [:placeholder/name
                                :placeholder/type
                                :placeholder/visualization-order]}
                              {:collection-placeholder-expression/item
                               pull-pattern-collection-item}])}
                    {[:rule/condition :as :predicate] [:macro/selector :predicate/operator :predicate/value
                                                       {:context-source/_macro [:context-source/alias]}]}]
                rule-ids)
   (mapv #(-> % ; for each rule, do:
              ;; convert predicates to vector/macro representation
              (update :predicate (fn [predicates]
                                   (cond
                                     (zero? (count predicates))
                                     true

                                     (= (count predicates) 1)
                                     (predicate-vector (first predicates))

                                     :else
                                     (into [:and] (map predicate-vector) predicates))))
              ;; set value for each placeholder override
              (update :assignments (fn [assignments]
                                     (->> assignments
                                          (sort-by (comp :placeholder/visualization-order
                                                         :placeholder/_override))
                                          (mapv (fn [assignment]
                                                  (ext-placeholder-expression
                                                   {:name (get-in assignment [:placeholder/_override :placeholder/name])
                                                    :placeholder/type (get-in assignment [:placeholder/_override :placeholder/type])
                                                    :expr assignment}))))))))))

(defn ext-context-source
  [{:context-source/keys [alias schema] :as cs}]
  (let [param (cs/parameter cs)
        original-parameter (cs/original-parameter cs)]
    (cond-> {:alias alias :schema schema}
      (some? original-parameter) (assoc :param original-parameter)
      (some? param) (assoc :param (if (and (map? original-parameter) (map? param))
                                    (merge original-parameter param)
                                    param)))))

(defn ext-context-sources [db c]
  (->> (d/pull db [:content-configuration/context-source] c)
       :content-configuration/context-source
       (mapv ext-context-source)))

(defn ext-content-function [db c meta]
  (let [placeholders (map second (dbseq/ordered (dbseq/->SequenceRelation
                                                 c
                                                 :content-configuration/placeholder
                                                 :placeholder/visualization-order)))
        rules (map second (dbseq/ordered (dbseq/->SequenceRelation
                                          c
                                          :content-configuration/rule
                                          :rule/execution-order)))]
    {:meta meta
     :data {:placeholders (ext-placeholders db placeholders)
            :rules (into [(ext-default-placeholder-value-as-rule0 db placeholders)] (ext-rules db rules))
            :context (ext-context-sources db c)}}))
